import { TApplicationState } from '../../types/redux';

export const selectPagination = (state: TApplicationState) => {
  return state.catalog.pagination;
};
